import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PosDetailWithOrders } from '../../../../../core/models/pos.model';
import { PosService } from '../../services/pos.service';
import { Order } from '../../../../../core/models/order.model';
import { Subject } from 'rxjs';
import { cloneDeep } from 'lodash-es';

@Component({
  selector: 'app-accounts-manager',
  templateUrl: './accounts-manager.component.html',
  styleUrls: ['./accounts-manager.component.scss']
})
export class AccountsManagerComponent implements OnInit {
  public pos: PosDetailWithOrders;
  public orders = [];
  loading: boolean;
  public originalOrders = [];
  private accountsChangeSubject: Subject<any>;

  constructor(
    private dialogRef: MatDialogRef<AccountsManagerComponent>,
    private posService: PosService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.pos = data?.pos;
    this.loading = false;
  }

  ngOnInit(): void {
    this.originalOrders = JSON.parse(JSON.stringify(this.pos.orders));
    this.orders = cloneDeep(this.pos.orders);
  }

  isAccountModified(order: Order, index: number): boolean {
    if (this.originalOrders[index]) {
      return order.name !== this.originalOrders[index].name;
    }
    return !!order.name; // For newly added accounts
  }

  onCancel() {
    // Close the dialog without saving
    this.dialogRef.close();
  }

  removeOrder(i: number) {
    const orderId = this.orders[i].id;
    if (orderId) {
      this.loading = true;
      this.posService.deletePosOrder(this.pos.pos.id, orderId).subscribe(data => {
        this.orders.splice(i, 1);
        this.loading = false;
      });
    } else {
      this.orders.splice(i, 1);
    }
  }

  calculateValues() {}

  addAccount() {
    this.orders.push({
      name: ''
    });
  }

  saveOrder(order: Order) {
    this.loading = true;
    if (order.id) {
      // Save logic for an existing order
      this.posService.updatePosOrder(this.pos.pos.id, order.id, order.name).subscribe(() => {
        this.updateOriginalOrder(order);
        this.onAccountsUpdated();
        this.loading = false;
      });
    } else {
      // Save logic for a new order
      this.posService.createPosOrder(this.pos.pos.id, order.name).subscribe(data => {
        // Update the order with ID from the server
        // @ts-ignore
        order.id = data.id;
        this.updateOriginalOrder(order);
        this.onAccountsUpdated();
        this.loading = false;
      });
    }
  }

  // Helper function to synchronize the original account copy
  updateOriginalOrder(order: Order) {
    const index = this.orders.indexOf(order);
    if (index !== -1) {
      this.originalOrders[index] = { ...order };
    }
  }

  onAccountsUpdated() {
    // Emit changes through the Subject
    // this.accountsChangeSubject.next();
  }

  public isOnlyContaGeral(order: Order): boolean {
    return order.name === 'Conta Geral' && this.orders.reduce((count, o) => (o.name === 'Conta Geral' ? count + 1 : count), 0) === 1;
  }
}
